// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3RX4_","label":"Completed_label__2oKKs"};